import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { SUIT, CIGAR, SHOES } from "src/constants/images";

export const image = (name) => {
  switch (name) {
    case "Shooting":
      // return SHOES.SOURCE;
      return "https://uwzrnpp6weg7rlv5aefndovthl2e5amufpolzxvfax4jouied5na.arweave.net/pbMWvf6xDfiuvQEK0bqzOvROgZQr3LzepQX4l1EEH1o";

    case "Racketeering":
      // return SUIT.SOURCE;
      return "https://4upd6kqsx473rkgzirlp4quwv2u3xw2i2jz3nnqiootoadr5kaza.arweave.net/5R4_KhK_P7io2URW_kKWrqm720jSc7a2CHOm4A49UDI";

    case "Strategy":
      return "https://6dgf5mub2saoe4y6eihctdxek54j7hquvr4oyodjxydwbbap55bq.arweave.net/8MxesoHUgOJzHiIOKY7kV3ifnhSseOw4ab4HYIQP70M";
    case "Gambling":
      return "https://he2writubgbyck7ngn2tq6ic4ggdkqqvappbtma27iesigvupz6q.arweave.net/OTVoonQJg4Er7TN1OHkC4Yw1QhUD3hmwGvoJJBq0fn0";

    case "Street Smart":
      return "https://jb65dtfe7332zv2c2fyb25smioz5wyk2osi5h3n2kcl3zpvtyp6a.arweave.net/SH3RzKT-96zXQtFwHXZMQ7PbYVp0kdPtulCXvL6zw_w";

    case "Critical Thinking":
      return "https://wvytncjy7rh6vcnv45lht24k6r5utm4hkrjmipxml3bb3rplmjxa.arweave.net/tXE2iTj8T-qJtedWeeuK9HtJs4dUUsQ-7F7CHcXrYm4";

    case "Intimidation":
      return "https://dp6rimgkamaim7qu6qpwzhqlagjit7wjztdzqzpgrabij2rbd6ea.arweave.net/G_0UMMoDAIZ-FPQfbJ4LAZKJ_snMx5hl5ogChOohH4g";

    case "Attention to Detail":
      return "https://ddhvn5gdzpnzcsn74yne7ymcippp2nycgsgvqkpsybcdwzlgxcnq.arweave.net/GM9W9MPL25FJv-YaT-GCQ979NwI0jVgp8sBEO2VmuJs";

    case "Physicality":
      return "https://2vqkkbrzzxn2gz72zayialal4njhzpclir5mez4blpk53vdyp7oa.arweave.net/1WClBjnN26Nn-sgwgCwL41J8vEtEesJngVvV3dR4f9w";

    case "Intelligence":
      return "https://457d2ve62sacdphqe5gubdsidbfkgdjnqlxzznvcdqliy4othxqq.arweave.net/5349VJ7UgCG88CdNQI5IGEqjDS2C75y2ohwWjHHTPeE";

    case "Logic":
      return "https://bxfgg7l4t4otvbimoz7eikub5b36tbre5677hrpesjdjirwshjgq.arweave.net/DcpjfXyfHTqFDHZ-RCqB6HfphiTvv_PF5JJGlEbSOk0";

    case "Incorruptible":
      return "https://ygt6khcqf5tldtmprqq76de2tam55mrr5hoolm6xb4fuzwxagbza.arweave.net/waflHFAvZrHNj4wh_wyamBnesjHp3OWz1w8LTNrgMHI";

    case "Persistence":
      return "https://ce24gbbmax3pstr7cfqfhu4ik7xrjkfz7slvcck7h3tbt3zgpasa.arweave.net/ETXDBCwF9vlOPxFgU9OIV-8UqLn8l1EJXz7mGe8meCQ";

    case "Critical thinking":
      return "https://mwjccwd5acuyddcyoe2wnmpnaod7kajeqdks3jsbf6b4gqedmhsq.arweave.net/ZZIhWH0AqYGMWHE1ZrHtA4f1ASSA1S2mQS-Dw0CDYeU";

    case "Courage":
      return "https://fhqfxb4ps66moblkaujevh2jnycjuume3kcgi52magovs7h2wvaq.arweave.net/KeBbh4-XvMcFagUSSp9JbgSaUYTahGR3TAGdWXz6tUE";

    case "Imagination":
      return "https://nhydbuj3fkhbrwuqmzbucjtbanbanuclesvatqar7ycoagcsny2a.arweave.net/afAw0TsqjhjakGZDQSZhA0IG0EskqgnAEf4E4BhSbjQ";

    case "Intuition":
      return "https://3b2adiesr6475ce256f2pbxc4vnjniw2soosdjvlvexaqazjj3uq.arweave.net/2HQBoJKPuf6Imu-Lp4bi5VqWotqTnSGmq6kuCAMpTuk";

    case "Communication":
      return "https://bqmspvczaphamdiuypkzity7w46kbaltyznorrsixyghxirl6emq.arweave.net/DBkn1FkDzgYNFMPVlE8ftzyggXPGWujGSL4Me6Ir8Rk";

    case "Leadership":
      return "https://glzjsrxqmorsrf2dgri42bbzrtigjlkndumrrb6smcrmpo7z5v7a.arweave.net/MvKZRvBjoyiXQzRRzQQ5jNBkrU0dGRiH0mCix7v57X4";

    case "Patience":
      return "https://du3tkrrudaybwqofygiwpuz73mqibxkp4knhajdxupwg46a4soba.arweave.net/HTc1RjQYMBtBxcGRZ9M_2yCA3U_imnAkd6Psbngck4I";

    default:
      return CIGAR.SOURCE;
  }
};

const StatData = ({ name, stat, className, statKey }) => {
  return (
    <div className="d-flex stats-data p-2">
      <p className={`mb-0 me-1  icon-container ${className}`}>
        <img src={image(name)} className="mb-1" />
      </p>
      <div className="mx-1">
        <p
          className={`stats mb-0 me-1 ${
            statKey % 2 ? "" : "orange"
          } ${statKey}`}
        >
          {stat ? parseInt(stat) : 0}
        </p>
        <p className="name mb-0">{name}</p>
      </div>
    </div>
  );
};

const GangstaStats = ({ data, nftData }) => {
  useEffect(() => {
    Object.entries(nftData.skills).map((key, value) => {
      console.log("****************", key[1][0], key[1][1]);
    });
  }, []);
  return (
    <div className="skill mt-4">
      <div className="card" style={{ backgroundColor: "red  !important" }}>
        <p className="title">Skills</p>
        <div className="row p-4 card-body">
          {nftData && nftData.skills ? (
            Object.entries(nftData.skills).map((key, value) => (
              <StatData
                key={key}
                name={key[1][0]}
                stat={key[1][1]}
                statKey={key}
                className={key[1][0].toLowerCase()}
              />
            ))
          ) : (
            <p>no stats</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default GangstaStats;

GangstaStats.propTypes = {
  data: PropTypes.any,
};

GangstaStats.defaultProps = {
  data: {
    Gambling: 0,
    Intelligence: 0,
    Patience: 0,
    Racketeering: 0,
    Shooting: 0,
  },
};
